import { useTranslation } from 'react-i18next';
import { StringKeys } from '../../../resources/strings/StringKeys';

const Unauthorized = () => {
  const { t } = useTranslation();

  return (
    <div className="loading-screen">
      <div style={{ textAlign: 'center', fontWeight: 'normal' }}>
        {t(StringKeys.YOU_ARE_UNAUTHORIZED_TO_VIEW_THIS_PAGE)}
      </div>
    </div>
  );
};

export default Unauthorized;
